
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M19.5 7l-2.142-5.569a1.452 1.452 0 00-2.713.007L12.5 7.1V15a.5.5 0 00.5.5h6a.5.5 0 00.5-.5zM.5 7.5h12v4H.5M16.5 18.5v5M14.5 18.5h4M20.728 20.429l2.259 1.071M21.058 17.536L23.5 17M12.272 20.429L10.013 21.5M11.942 17.536L9.5 17"}})])
          )
        }
      }
    